var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media / Icons / General / Calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.66732 2.16663V5.49996M13.334 2.16663V5.49996M10.0007 13H13.334M3.33398 9.66663H16.6673M6.66732 13H6.75065M5.00065 17.1666H15.0007C15.9211 17.1666 16.6673 16.4204 16.6673 15.5V5.49996C16.6673 4.57948 15.9211 3.83329 15.0007 3.83329H5.00065C4.08018 3.83329 3.33398 4.57948 3.33398 5.49996V15.5C3.33398 16.4204 4.08018 17.1666 5.00065 17.1666Z",
    stroke: "#404040",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDark);
export default __webpack_public_path__ + "static/media/calendar-dark.713445a8fa434b5b745c4564201fb5e2.svg";
export { ForwardRef as ReactComponent };